import * as groupGochiMenuActions from '../actions/GroupGochiMenus';

const initialState = {
  groupMenus: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  taxTypes: [
    {
      id: 'EXTERNAL',
      name: '外税'
    },
    {
      id: 'INTERNAL',
      name: '内税'
    }
  ],
  detail: {
    groupId: 1,
    menuId: 1,
    groupName: 'グループA',
    menuName: 'オムライス',
    description: 'ふわっふわなオムライスです。',
    price: 800,
    taxType: 'INTERNAL',
    taxTypeStr: '内税',
    reducedTax: 'UNREDUCED',
    image:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/menu/omu.png',
    createdAt: '2019-01-01 12:00:00',
    updatedAt: '2019-02-01 12:00:00',
    tags: [
      {
        tagId: 1,
        tagName: 'タグ1',
        viewOrder: 1
      },
      {
        tagId: 2,
        tagName: 'タグ2',
        viewOrder: 2
      },
      {
        tagId: 3,
        tagName: 'タグ3',
        viewOrder: 3
      },
      {
        tagId: 4,
        tagName: 'タグ4',
        viewOrder: 4
      },
      {
        tagId: 5,
        tagName: 'タグ5',
        viewOrder: 5
      },
      {
        tagId: 6,
        tagName: 'タグ6',
        viewOrder: 6
      }
    ]
  },
  error: false,
  status: 200,
  error_message: ''
};

const gochiMenus = (state = initialState, action) => {
  switch (action.type) {
    case groupGochiMenuActions.GET_GROUP_GOCHI_MENUS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case groupGochiMenuActions.GET_GROUP_GOCHI_MENUS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case groupGochiMenuActions.GET_GROUP_GOCHI_MENU_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case groupGochiMenuActions.GET_GROUP_GOCHI_MENU_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default gochiMenus;
